import { ONSEN_APP } from "helpers/environment";
import useDOMEvent from "helpers/useDOMEvent";
import React, { createContext, useState } from "react";

export const SUPPORT_BROWSER_FULLSCREEN = !!document.body.requestFullscreen || ONSEN_APP;

export const fullscreenStateContext = createContext();

export default function FullscreenStateProvider({ children }) {
  const [fullscreen, fullscreenSetRaw] = useState(() => !!document.fullscreenElement);

  useDOMEvent(
    "fullscreenchange",
    () => {
      if (SUPPORT_BROWSER_FULLSCREEN) fullscreenSetRaw(!!document.fullscreenElement);
    },
    () => document,
  );

  const fullscreenSet = (value) => {
    if (SUPPORT_BROWSER_FULLSCREEN && !ONSEN_APP) {
      if (value && !document.fullscreenElement) {
        document.body.requestFullscreen();
      } else if (!value && document.fullscreenElement) {
        document.exitFullscreen();
      }
    } else fullscreenSetRaw(value);
  };

  return (
    <fullscreenStateContext.Provider value={{ fullscreen, fullscreenSet }}>{children}</fullscreenStateContext.Provider>
  );
}
